import React from 'react';
import './InitialBookingDisclaimer.sass';

export default function InitialBookingDisclaimer() {
  return (
    <>
      <p className="initial-booking-disclaimer">
        Note: These appointments are not for emergencies. For urgent medical help, please call 111.
      </p>
    </>
  );
}
